import * as React from 'react';
import { SVGProps } from 'react';

const IconLithologyFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2Zm3 3V2h2v2H5ZM4 5H2v2h2V5Zm4 0h2v2H8V5Zm-3 5V8h2v2H5Z"
    />
  </svg>
);
export default IconLithologyFilledSizeXs;
